export enum Pages {
    none,
    login,
    dashboard
}